export default "__VITE_ASSET__auN0NuwN__"